import React from 'react';
import { IAlertState } from '../../interface/alert-state.interface';
import CloseBtn from './CloseBtn';
import { useGetLangDirectionApp } from '../../stores/app.store';

type Props = {
    state: IAlertState,
    alertSize?: 'small' | 'medium' | 'large',
    onClose?: () => void;
}

const AlertUser: React.FC<Props> = ({
    state,
    alertSize = 'medium',
    onClose = undefined
}) => {

    const langDirection = useGetLangDirectionApp();
    const { alertStatus, message, alertColor } = state;
    const isRtl = langDirection === 'rtl';

    if (alertStatus !== 'hasAlert') {
        return null;
    }

    let classes = `alert alert-${alertColor || 'info'} 
        border-5 border-top-0 border-bottom-0 rounded-1 
        border-${isRtl ? 'start' : 'end'}-0`;

    return (
        <div className={classes}>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '1.2rem'
            }} >
                <div style={{ display: 'inline', fontSize: '1.1rem' }}>{message}</div>
                {onClose && <CloseBtn onClick={onClose} />}
            </div>
        </div>
    );
}

export default AlertUser;